// extracted by mini-css-extract-plugin
module.exports = {"wrap":"list_wrap__2flkn","sectionTit":"list_sectionTit__2PCYI","footer":"list_footer__LX8D0","tabs":"list_tabs__3fUiq"};